import { graphql } from 'react-relay';

export default graphql`
    query headerRootQuery(
        $isClient: Boolean = false
        $hasUserId: Boolean!
        $previewKey: String = ""
        $userId: String!
        $userIds: [String]!
        $fetchRegionalInfo: Boolean!
        $showMarketingMessages: Boolean!
        $hasMarketingBannerPreviewVariables: Boolean = false
        $marketingBannerPreviewUserType: String = ""
        $marketingBannerPreviewSetId: String = ""
        $marketingBannerIsFirstTimeVisitor: Boolean = false
        $fetchTradeNav: Boolean!
        $fetchNav: Boolean!
        $zipCode: String!
        $userCountryCode: String = ""
        $hasSessionCountryCode: Boolean!
    ) {
        viewer {
            ...Header_viewer
        }
    }
`;

export const initialVariables = {
    isClient: false,
    hasUserId: false,
    previewKey: '',
    hasMarketingBannerPreviewVariables: false,
    fetchMarketingMessagesTransactions: false,
    showMarketingMessages: false,
    fetchRegionalInfo: false,
    fetchTradeNav: false,
    fetchNav: false,
    userId: '',
    userIds: [],
    zipCode: '',
    userCountryCode: '',
    hasSessionCountryCode: false,
};
